import $ from "cash-dom"
import Siema from 'siema'

export default class SlidesModule {

    static name = 'slides'

    constructor(node) {

        const $slides = $(node)
        const amount = $slides.find('.slides__item').length
        
        this.interval = null
        this.intervalTime = parseFloat($slides.data('interval')) || false

        //build dots
        const $dots = $('<div class="slides__dots"></div>')
        for(let i=0; i<amount; i++) {
            $('<button class="slides__dot"></button>')
                .data('i', i)
                .addClass(i === 0 ? 'active' : '')
                .appendTo($dots)
        }
        $dots.prepend('<button class="slides__left"></button>');
        $dots.append('<button class="slides__right"></button>');
        $dots.insertAfter($slides.find('.siema'))

        const siema = this.siema = new Siema({
            selector: node.querySelector('.siema'),
            duration: 660,
            loop: true,
            onChange: () => {

                const i = siema.currentSlide

                $slides
                    .removeClass('slides--first slides--last')
                    .find('.slides__dot')
                    .eq(i)
                    .addClass('active')
                    .siblings()
                    .removeClass('active')

                if(i === 0) {
                    $slides.addClass('slides--first')
                } else if(i === amount - 1) {
                    $slides.addClass('slides--last')
                }
            }
        })

        $slides
            .on('click', '.slides__dot', function() {
                siema.goTo($(this).data('i'))
            })
            .on('click', '.slides__left', () => {
                siema.prev()
            })
            .on('click', '.slides__right', () => {
                siema.next()
            })
            .on('mouseenter', () => {
                window.clearInterval(this.interval)
            })
            .on('mouseleave', () => {
                this.setInterval()
            })

        $(window)
            .on('visibilitychange', () => {
                if(document.hidden) {
                    window.clearInterval(this.interval)
                } else {
                    this.setInterval()
                }
            })

        this.setInterval()
    }

    setInterval = () => {

        if(!this.intervalTime) return

        //make sure there is only one interval
        window.clearInterval(this.interval)

        //autoscroll
        this.interval = window.setInterval(() => {
            this.siema.next()
        }, this.intervalTime * 1000)
    }
}